
import Vue from 'vue';
export default Vue.extend({
  name: 'Video',
  props: {
    videoSrc: String,
    cover: String,
    coverWEBP: String,
    coverJP2: String,
    coverJXR: String,
  },
  data() {
    return {
      iframe: false,
      isMobile: (document.body.clientWidth > 640) ? false : true,
    };
  },
  created() {
    window.addEventListener('resize', this.checkWidth);
  },
  destroyed() {
    window.removeEventListener('resize', this.checkWidth);
  },
  methods: {
    showIframe() {
      this.iframe = true;
    },
    checkWidth() {
      this.isMobile = (document.body.clientWidth > 640) ? false : true;
    },
  },
});
